import React, { createContext, useState, useContext, useEffect,useMemo } from "react";
import { Colors } from "./utils";
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(Colors.dark); // Default to light theme

  const toggleTheme = () => {
    const newTheme = theme === Colors.light ? Colors.dark : Colors.light;

    setTheme(newTheme);
    localStorage.setItem("TwinBuilder3DTheme", newTheme);

    const evt = new CustomEvent("SetWebGLTheme", {
        detail: {
            theme: newTheme, // ✅ Use the correct new theme
        },
    });
    window.dispatchEvent(evt);
};

  useEffect(() => {
    setTheme(Colors.dark);
  }, []);
    return (
        <ThemeContext.Provider
            value={useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme])}
        >
            {children}
        </ThemeContext.Provider>
    );
};
export const useTheme = () => useContext(ThemeContext);
